import React, { useMemo } from 'react';
import RefQueue from '../common/ref-queue';

const useRefQueue = <T>() => {
  const instance = useMemo<RefQueue<T>>(() => new RefQueue(), []);

  return instance;
};

export default useRefQueue;
